module.exports = __webpack_public_path__ + "static/img/coupontop.43c54418.png";